import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/** Keep the header light over photography; switch text contrast after leaving it. */
export function useHeroHeader() {
  const { pathname } = useLocation();
  const home = pathname.startsWith('/buyer/home');
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    if (!home) return;
    const hero = document.querySelector('.buyer-hero');
    if (!hero) return;
    const observer = new IntersectionObserver(([entry]) => setVisible(entry.isIntersecting), {
      rootMargin: '-64px 0px 0px 0px', threshold: 0,
    });
    observer.observe(hero);
    return () => observer.disconnect();
  }, [home]);
  return home && visible;
}
